import { upsellPageAnalyticsRecordSchema } from "@redotech/redo-model/one-click-upsell/upsell-page-analytics-record";
import { z } from "zod";

export const getUpsellPageAnalytics = {
  input: z.null(),
  output: z.object({
    upsellPageAnalyticsRecords: z.array(upsellPageAnalyticsRecordSchema),
  }),
};
